/**
 * Custom JavaScript for Artizan Coffee
 * This file contains all custom functionality separate from theme.js
 */

// Reviews.io placeholder handler
function checkReviewsPlaceholders() {
  document.querySelectorAll('.ruk_rating_snippet').forEach(function(element) {
    // Check if Reviews.io hasn't populated the element
    const hasReviewContent = element.querySelector('.ruk-rating-snippet-stars, .RatingSnippet, i[class*="ruk-icon"]');
    const placeholder = element.querySelector('.no-reviews-placeholder');
    
    if (!hasReviewContent && placeholder) {
      // Show placeholder if no review content
      placeholder.style.display = 'block';
    } else if (hasReviewContent && placeholder) {
      // Hide placeholder if reviews are loaded
      placeholder.style.display = 'none';
    }
  });
} 

// Check after page loads
document.addEventListener('DOMContentLoaded', function() {
  // Initial check after Reviews.io typically loads
  setTimeout(checkReviewsPlaceholders, 2000);
  
  // Additional check in case of slow loading
  setTimeout(checkReviewsPlaceholders, 4000);
});

// Also check when collections are dynamically updated
document.addEventListener('collection:updated', checkReviewsPlaceholders);

// Log to confirm custom.js is loaded
console.log('Custom.js loaded successfully');


document.addEventListener('DOMContentLoaded', function() {
  const skipLink = document.querySelector('.skip-to-content');
  if (skipLink) {
    skipLink.addEventListener('click', function(e) {
      e.preventDefault();
      let target = document.querySelector('#main-content');
      if (!target) {
        target = document.querySelector('main');
        if (target) target.setAttribute('id', 'main-content');
      }
      if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus();
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  // Fix 1: Remove focusability from links inside aria-hidden slides
  function fixAriaHiddenFocusable() {
    const hiddenSlides = document.querySelectorAll('.slideshow__slide[aria-hidden="true"]');
    hiddenSlides.forEach(function(slide) {
      const focusable = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      focusable.forEach(function(el) {
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  fixAriaHiddenFocusable();

  // Re-run when slideshow changes
  const observer = new MutationObserver(fixAriaHiddenFocusable);
  const slideshow = document.querySelector('.slideshow__slide');
  if (slideshow && slideshow.parentElement) {
    observer.observe(slideshow.parentElement, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  // Fix 2: Add aria-label to empty ppspy extension link
  const ppspyLink = document.querySelector('a.extension-logo[href*="ppspy.com"]');
  if (ppspyLink) {
    ppspyLink.setAttribute('aria-label', 'PPSpy Extension');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Fix 3: Fix nested interactive controls in mega menu
  const summaries = document.querySelectorAll('details[is="mega-menu-disclosure"] > summary');
  summaries.forEach(function(summary) {
    const nestedLinks = summary.querySelectorAll('a');
    nestedLinks.forEach(function(link) {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
    });
  });
});

// Fix ppspy link - inject after delay
setTimeout(function() {
  const ppspyLink = document.querySelector('a.extension-logo[href*="ppspy.com"]');
  if (ppspyLink) {
    ppspyLink.setAttribute('aria-label', 'PPSpy Extension');
  }
}, 6000);

// Fix ppspy - watch for it being added to DOM
const ppspyObserver = new MutationObserver(function() {
  const ppspyLink = document.querySelector('a.extension-logo[href*="ppspy.com"]');
  if (ppspyLink && !ppspyLink.getAttribute('aria-label')) {
    ppspyLink.setAttribute('aria-label', 'PPSpy Extension');
    ppspyObserver.disconnect();
  }
});
ppspyObserver.observe(document.body, { childList: true, subtree: true });

setTimeout(function() {
  const hideIcon = document.querySelector('.asw-hide-widget-icon');
  if (hideIcon) {
    hideIcon.removeAttribute('role');
    hideIcon.removeAttribute('tabindex');
    hideIcon.setAttribute('aria-hidden', 'true');
  }
}, 4000);


(function fixAxeIssues() {

  // ─────────────────────────────────────────────
  // FIX 1: Links must have discernible text
  // Target: .extension-logo anchor (empty <a>)
  // ─────────────────────────────────────────────
  function fixEmptyExtensionLogoLink() {
    const links = document.querySelectorAll(
      '.extension-logo[rel="noreferrer"][target="_blank"], .extension-logo[href]'
    );

    links.forEach((link) => {
      const hasText = link.textContent.trim().length > 0;
      const hasAriaLabel = link.getAttribute("aria-label");
      const hasAriaLabelledBy = link.getAttribute("aria-labelledby");
      const hasTitle = link.getAttribute("title");
      const hasAriaHidden = link.getAttribute("aria-hidden") === "true";

      const imgChild = link.querySelector("img, svg");

      if (!hasText && !hasAriaLabel && !hasAriaLabelledBy && !hasTitle && !hasAriaHidden) {
        if (imgChild) {
          const imgAlt = imgChild.getAttribute("alt");
          const href = link.getAttribute("href") || "";
          let labelText = imgAlt && imgAlt.trim()
            ? imgAlt.trim()
            : "Visit " + (href ? new URL(href).hostname : "external site");

          link.setAttribute("aria-label", labelText);

          if (imgChild.tagName === "IMG") {
            imgChild.setAttribute("alt", "");
          } else if (imgChild.tagName === "SVG") {
            imgChild.setAttribute("aria-hidden", "true");
          }
        } else {
          link.setAttribute("aria-hidden", "true");
          link.setAttribute("tabindex", "-1");
        }
      }
    });
  }

  // ─────────────────────────────────────────────
  // FIX 2: Interactive controls must not be nested
  // Target: AccessiBe #asw-icon button contains
  // a div[role="button"] child — nested interactive
  // ─────────────────────────────────────────────
  function fixNestedInteractiveControls() {
    const outerBtn = document.querySelector("#asw-icon");
    if (!outerBtn) return;

    const nestedInteractive = outerBtn.querySelectorAll(
      '[role="button"], [role="link"], a[href], button, input, select, textarea'
    );

    nestedInteractive.forEach((el) => {
      if (el.hasAttribute("role")) {
        el.removeAttribute("role");
      }
      el.setAttribute("tabindex", "-1");
      el.setAttribute("aria-hidden", "true");
      if (el.hasAttribute("aria-label")) {
        el.removeAttribute("aria-label");
      }
    });
  }

  function runFixes() {
    fixEmptyExtensionLogoLink();
    fixNestedInteractiveControls();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runFixes);
  } else {
    runFixes();
  }

  const observer = new MutationObserver(function (mutations) {
    let shouldRerun = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (
            node.id === "asw-icon" ||
            node.classList?.contains("asw-icon") ||
            node.classList?.contains("extension-logo") ||
            node.querySelector?.("#asw-icon, .extension-logo")
          ) {
            shouldRerun = true;
          }
        }
      });
    });

    if (shouldRerun) runFixes();
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();


(function fixNestedInteractiveInSummary() {

  // ── ISSUE 1: mega-menu-disclosure ────────────────────────────
  // summary contains <a href> — remove href to kill focusability
  // Also contains <button class="submenu-toggle"> — replace with span
  // ── ISSUE 2: dropdown-disclosure ────────────────────────────
  // summary contains <button class="submenu-toggle">
  // role="presentation" does NOT remove native button focusability
  // Must replace the <button> with a <span> in the DOM
  // ─────────────────────────────────────────────────────────────

  function fixMegaMenuDisclosure() {
    document.querySelectorAll('details[is="mega-menu-disclosure"]').forEach((detail) => {
      const summary = detail.querySelector(':scope > summary');
      if (!summary) return;

      // ── Fix nested <a href> links ──────────────────────────────
      summary.querySelectorAll('a[href]').forEach((link) => {
        const linkText = link.textContent.trim();
        if (linkText && !summary.getAttribute('aria-label')) {
          summary.setAttribute('aria-label', linkText);
        }
        const href = link.getAttribute('href');
        if (href) {
          link.removeAttribute('href');
          link.setAttribute('data-original-href', href);
        }
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
        if (link.hasAttribute('role')) link.removeAttribute('role');
      });

      // ── Fix nested <button> inside mega-menu summary ───────────
      summary.querySelectorAll('button.submenu-toggle, button[aria-label*="Submenu"]').forEach((btn) => {
        const btnLabel = btn.getAttribute('aria-label') || btn.textContent.trim();
        const expanded = btn.getAttribute('aria-expanded');
        const controls = btn.getAttribute('aria-controls');

        if (btnLabel && !summary.getAttribute('aria-label')) {
          summary.setAttribute('aria-label', btnLabel);
        }
        if (expanded !== null && !summary.hasAttribute('aria-expanded')) {
          summary.setAttribute('aria-expanded', expanded);
        }
        if (controls && !summary.getAttribute('aria-controls')) {
          summary.setAttribute('aria-controls', controls);
        }

        if (!detail._toggleListenerAdded) {
          detail.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(detail.open));
          });
          detail._toggleListenerAdded = true;
        }

        // Replace button with span — only DOM replacement works
        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.className = btn.className;
        while (btn.firstChild) span.appendChild(btn.firstChild);
        btn.parentNode.replaceChild(span, btn);
      });

    });
  }

  function fixDropdownDisclosure() {
    document.querySelectorAll('details[is="dropdown-disclosure"]').forEach((detail) => {
      const summary = detail.querySelector(':scope > summary');
      if (!summary) return;

      summary.querySelectorAll('button.submenu-toggle').forEach((btn) => {
        const btnLabel   = btn.getAttribute('aria-label') || btn.textContent.trim();
        const expanded   = btn.getAttribute('aria-expanded');
        const controls   = btn.getAttribute('aria-controls');

        if (btnLabel && !summary.getAttribute('aria-label')) {
          summary.setAttribute('aria-label', btnLabel);
        }
        if (expanded !== null && !summary.hasAttribute('aria-expanded')) {
          summary.setAttribute('aria-expanded', expanded);
        }
        if (controls && !summary.getAttribute('aria-controls')) {
          summary.setAttribute('aria-controls', controls);
        }

        if (!detail._toggleListenerAdded) {
          detail.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(detail.open));
          });
          detail._toggleListenerAdded = true;
        }

        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        while (btn.firstChild) {
          span.appendChild(btn.firstChild);
        }
        span.className = btn.className;
        btn.parentNode.replaceChild(span, btn);
      });

      // Neutralize any other stray focusable descendants
      summary.querySelectorAll(
        'a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ).forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
        if (el.tagName === 'A') el.removeAttribute('href');
      });
    });
  }

  function runFixes() {
    fixMegaMenuDisclosure();
    fixDropdownDisclosure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes);
  } else {
    runFixes();
  }

  // Watch for dynamically injected menus
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('details[is="mega-menu-disclosure"], details[is="dropdown-disclosure"]') ||
          node.querySelector?.('details[is="mega-menu-disclosure"], details[is="dropdown-disclosure"]')
        ) {
          shouldRun = true;
          break;
        }
      }
      if (shouldRun) break;
    }
    if (shouldRun) runFixes();
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();


(function fixExtensionLogoEmptyLink() {

  function fix() {
    const links = document.querySelectorAll(
      'a.extension-logo[rel="noreferrer"][target="_blank"]'
    );

    links.forEach((link) => {
      const hasText = link.textContent.trim().length > 0;
      const hasLabel = link.getAttribute('aria-label');
      const hasLabelledBy = link.getAttribute('aria-labelledby');
      const hasTitle = link.getAttribute('title');

      if (!hasText && !hasLabel && !hasLabelledBy && !hasTitle) {
        const img = link.querySelector('img');
        const svg = link.querySelector('svg');

        if (img) {
          const alt = img.getAttribute('alt')?.trim();
          link.setAttribute('aria-label', alt || 'ppspy - Visit external site');
          img.setAttribute('alt', '');
        } else if (svg) {
          svg.setAttribute('aria-hidden', 'true');
          link.setAttribute('aria-label', 'ppspy - Visit external site');
        } else {
          link.setAttribute('aria-hidden', 'true');
          link.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('a.extension-logo') ||
          node.querySelector?.('a.extension-logo')
        ) {
          fix();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

})();


(function fixRukRatingSnippets() {

  function buildLabel(el) {
    const ratingText = el.textContent.trim();
    if (ratingText.length > 0) {
      const numMatch = ratingText.match(/(\d+(\.\d+)?)/);
      if (numMatch) {
        return `Rated ${numMatch[1]} out of 5 stars`;
      }
      return `Rating: ${ratingText}`;
    }

    const score = el.getAttribute('data-score') ||
                  el.getAttribute('data-rating') ||
                  el.getAttribute('data-average');
    const count = el.getAttribute('data-count') ||
                  el.getAttribute('data-reviews-count') ||
                  el.getAttribute('data-number-of-reviews');

    if (score) {
      return count
        ? `Rated ${score} out of 5 stars based on ${count} reviews`
        : `Rated ${score} out of 5 stars`;
    }

    return 'Customer rating';
  }

  function fixAll() {
    const snippets = document.querySelectorAll(
      'div.ruk_rating_snippet[role="img"]'
    );

    snippets.forEach((el) => {
      const hasLabel = el.getAttribute('aria-label')?.trim();
      const hasLabelledBy = el.getAttribute('aria-labelledby');
      const hasTitle = el.getAttribute('title')?.trim();

      if (!hasLabel && !hasLabelledBy && !hasTitle) {
        const label = buildLabel(el);
        el.setAttribute('aria-label', label);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }

  const observer = new MutationObserver((mutations) => {
    let relevant = false;

    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('div.ruk_rating_snippet') ||
          node.querySelector?.('div.ruk_rating_snippet')
        ) {
          relevant = true;
          break;
        }
      }

      if (
        m.target?.classList?.contains('ruk_rating_snippet') ||
        m.target?.closest?.('div.ruk_rating_snippet')
      ) {
        relevant = true;
      }

      if (relevant) break;
    }

    if (relevant) fixAll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-score', 'data-rating', 'data-average', 'data-count']
  });

})();


// ── MASTER ACCESSIBILITY FIX RUNNER ─────────────────────────────
(function masterA11yRunner() {

  var delays = [0, 500, 1000, 2000, 3000, 5000, 8000, 12000];

  function runAllFixes() {

    // 1. ppspy empty link
    document.querySelectorAll(
      'a.extension-logo[rel="noreferrer"][target="_blank"], a.extension-logo[href*="ppspy.com"]'
    ).forEach(function(link) {
      if (!link.getAttribute('aria-label') &&
          !link.getAttribute('aria-labelledby') &&
          !link.getAttribute('title')) {
        var img = link.querySelector('img');
        var svg = link.querySelector('svg');
        if (img) {
          link.setAttribute('aria-label', img.getAttribute('alt')?.trim() || 'ppspy - Visit external site');
          img.setAttribute('alt', '');
        } else if (svg) {
          svg.setAttribute('aria-hidden', 'true');
          link.setAttribute('aria-label', 'ppspy - Visit external site');
        } else {
          link.setAttribute('aria-hidden', 'true');
          link.setAttribute('tabindex', '-1');
        }
      }
    });

    // 2. AccessiBe nested button
    var aswIcon = document.querySelector('#asw-icon');
    if (aswIcon) {
      aswIcon.querySelectorAll(
        '.asw-hide-widget-icon, [role="button"], [role="link"]'
      ).forEach(function(el) {
        el.removeAttribute('role');
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
        el.removeAttribute('aria-label');
      });
    }

    // 3. Reviews.io ruk_rating_snippet
    document.querySelectorAll('div.ruk_rating_snippet[role="img"]').forEach(function(el) {
      if (el.getAttribute('aria-label')?.trim()) return;
      var text = el.textContent.trim();
      var numMatch = text.match(/(\d+(\.\d+)?)/);
      var score = el.getAttribute('data-score') || el.getAttribute('data-rating') || el.getAttribute('data-average');
      var count = el.getAttribute('data-count') || el.getAttribute('data-reviews-count');
      var label = 'Customer rating';
      if (numMatch) {
        label = 'Rated ' + numMatch[1] + ' out of 5 stars';
      } else if (score) {
        label = count
          ? 'Rated ' + score + ' out of 5 stars based on ' + count + ' reviews'
          : 'Rated ' + score + ' out of 5 stars';
      }
      el.setAttribute('aria-label', label);
    });

    // 4. mega-menu nested links + buttons
    document.querySelectorAll(
      'details[is="mega-menu-disclosure"] > summary, details[is="dropdown-disclosure"] > summary'
    ).forEach(function(summary) {
      // Fix nested links
      summary.querySelectorAll('a[href]').forEach(function(link) {
        var text = link.textContent.trim();
        if (text && !summary.getAttribute('aria-label')) {
          summary.setAttribute('aria-label', text);
        }
        link.removeAttribute('href');
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      });

      // Fix nested buttons — replace with span
      summary.querySelectorAll('button.submenu-toggle, button[aria-label*="Submenu"]').forEach(function(btn) {
        if (btn.parentNode) {
          var span = document.createElement('span');
          span.setAttribute('aria-hidden', 'true');
          span.className = btn.className;
          while (btn.firstChild) span.appendChild(btn.firstChild);
          btn.parentNode.replaceChild(span, btn);
        }
      });
    });

    // 6. aria-hidden slideshow focusable elements
    document.querySelectorAll('.slideshow__slide[aria-hidden="true"]').forEach(function(slide) {
      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function(el) {
        el.setAttribute('tabindex', '-1');
      });
    });


    // 15. Scrollable region keyboard access
    // scroll-carousel with role="region" must be focusable for keyboard users
    document.querySelectorAll(
      'scroll-carousel.is-scrollable, [role="region"].is-scrollable, scroll-carousel[role="region"]'
    ).forEach(function(el) {
      // Only add tabindex if element has no focusable children already
      if (!el.getAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
      // Ensure it has an accessible name so role="region" is valid
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        // Try to find a heading sibling or parent heading
        var heading = el.closest('section, .section')?.querySelector('h1, h2, h3, h4');
        if (heading && heading.textContent.trim()) {
          el.setAttribute('aria-label', heading.textContent.trim());
        } else {
          el.setAttribute('aria-label', 'Scrollable content');
        }
      }
    });


    // 16. Blog post card contrast fixes
    // Featured card: remove text-shadow that fails contrast
    // Use MutationObserver to fight theme overriding color back to white
    function fixFeaturedCardText() {
      document.querySelectorAll(
        'blog-post-card.blog-post-card--featured p.text-lg, .blog-post-card--featured p.text-lg'
      ).forEach(function(el) {
        el.style.setProperty('text-shadow', 'none', 'important');
        el.style.setProperty('color', '#0F3E36', 'important');



        // Watch this specific element for style changes and re-apply
        if (!el._contrastObserver) {
          el._contrastObserver = new MutationObserver(function() {
            if (el.style.color !== 'rgb(15, 62, 54)') {
              el.style.setProperty('text-shadow', 'none', 'important');
              el.style.setProperty('color', '#0F3E36', 'important');
            }
          });
          el._contrastObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
        }
      });
    }

    fixFeaturedCardText();

    // Blog meta date text — set to #0F3E36 with observer to prevent theme override
    document.querySelectorAll(
      '.blog-post-card__meta .text-with-icon .text-sm, .blog-post-card__meta .link-faded .text-sm, .blog-post-card__meta span.text-sm, blog-post-card .blog-post-card__meta span.text-sm'
    ).forEach(function(el) {
      el.style.setProperty('color', '#0F3E36', 'important');

      if (!el._dateContrastObserver) {
        el._dateContrastObserver = new MutationObserver(function() {
          if (el.style.color !== 'rgb(15, 62, 54)') {
            el.style.setProperty('color', '#0F3E36', 'important');
          }
        });
        el._dateContrastObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
      }
    });


    // Fix: featured blog post card text-lg color
document.addEventListener('DOMContentLoaded', function() {
  const featuredCard = document.querySelector('blog-post-card.blog-post-card--featured');
  if (featuredCard) {
    const textLg = featuredCard.querySelector('p.text-lg');
    if (textLg) {
      textLg.style.setProperty('color', '#0F3E36', 'important');
      textLg.style.setProperty('background-color', 'rgba(0, 0, 0, 0.01)', 'important');
    }
  }
});

    // 15. Scrollable region keyboard access
    // scroll-carousel with role="region" must be focusable for keyboard users
    document.querySelectorAll(
      'scroll-carousel.is-scrollable, [role="region"].is-scrollable, scroll-carousel[role="region"]'
    ).forEach(function(el) {
      // Only add tabindex if element has no focusable children already
      if (!el.getAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
      // Ensure it has an accessible name so role="region" is valid
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        // Try to find a heading sibling or parent heading
        var heading = el.closest('section, .section')?.querySelector('h1, h2, h3, h4');
        if (heading && heading.textContent.trim()) {
          el.setAttribute('aria-label', heading.textContent.trim());
        } else {
          el.setAttribute('aria-label', 'Scrollable content');
        }
      }
    });

    // 17. Fix tap-area button touch target size
    document.querySelectorAll('button.tap-area').forEach(function(btn) {
      btn.style.setProperty('min-width', '24px', 'important');
      btn.style.setProperty('min-height', '24px', 'important');
      btn.style.setProperty('padding', '8px', 'important');
      btn.style.setProperty('margin', '4px', 'important');
      btn.style.setProperty('box-sizing', 'border-box', 'important');
    });

   // 18. Fix empty buttons — aggressive version
    function fixEmptyButtons() {
      document.querySelectorAll('button').forEach(function(btn) {

        // Force hide all SVGs inside buttons from AT
        btn.querySelectorAll('svg').forEach(function(svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
          svg.setAttribute('role', 'presentation');
        });

        // Check if button has any accessible name at all
        var hasAriaLabel = btn.getAttribute('aria-label') && btn.getAttribute('aria-label').trim();
        var hasAriaLabelledBy = btn.getAttribute('aria-labelledby');
        var hasTitle = btn.getAttribute('title') && btn.getAttribute('title').trim();

        // Get text content excluding sr-only spans (they count as accessible text)
        var fullText = btn.textContent.trim();

        // Skip if already has any accessible name
        if (hasAriaLabel || hasAriaLabelledBy || hasTitle || fullText) return;

        // Identify and label
        var cls = btn.className || '';
        var parentCls = (btn.parentElement && btn.parentElement.className) || '';
        var formAction = btn.closest('form') ? (btn.closest('form').getAttribute('action') || '') : '';
        var svgClass = '';
        var svgEl = btn.querySelector('svg');
        if (svgEl) svgClass = svgEl.getAttribute('class') || '';

        if (svgClass.indexOf('search') > -1 || formAction.indexOf('search') > -1 ||
            cls.indexOf('search') > -1 || parentCls.indexOf('search') > -1 ||
            btn.type === 'submit') {
          btn.setAttribute('aria-label', 'Search');

        } else if (svgClass.indexOf('cart') > -1 || cls.indexOf('cart') > -1 ||
                   parentCls.indexOf('cart') > -1) {
          btn.setAttribute('aria-label', 'View cart');

        } else if (svgClass.indexOf('close') > -1 || cls.indexOf('close') > -1 ||
                   parentCls.indexOf('close') > -1) {
          btn.setAttribute('aria-label', 'Close');

        } else if (svgClass.indexOf('menu') > -1 || cls.indexOf('menu') > -1 ||
                   cls.indexOf('hamburger') > -1 || cls.indexOf('nav-toggle') > -1) {
          btn.setAttribute('aria-label', 'Open menu');

        } else if (svgClass.indexOf('account') > -1 || cls.indexOf('account') > -1 ||
                   cls.indexOf('login') > -1 || cls.indexOf('user') > -1) {
          btn.setAttribute('aria-label', 'Account');

        } else if (svgClass.indexOf('wishlist') > -1 || cls.indexOf('wishlist') > -1 ||
                   cls.indexOf('favorite') > -1) {
          btn.setAttribute('aria-label', 'Wishlist');

        } else if (svgClass.indexOf('play') > -1 || cls.indexOf('play') > -1) {
          btn.setAttribute('aria-label', 'Play');

        } else if (svgClass.indexOf('pause') > -1 || cls.indexOf('pause') > -1) {
          btn.setAttribute('aria-label', 'Pause');

        } else if (svgClass.indexOf('arrow') > -1 || cls.indexOf('prev') > -1 ||
                   cls.indexOf('previous') > -1) {
          btn.setAttribute('aria-label', 'Previous');

        } else if (cls.indexOf('next') > -1) {
          btn.setAttribute('aria-label', 'Next');

        } else if (svgClass.indexOf('share') > -1 || cls.indexOf('share') > -1) {
          btn.setAttribute('aria-label', 'Share');

        } else if (svgClass.indexOf('filter') > -1 || cls.indexOf('filter') > -1) {
          btn.setAttribute('aria-label', 'Filter');

        } else if (svgClass.indexOf('sort') > -1 || cls.indexOf('sort') > -1) {
          btn.setAttribute('aria-label', 'Sort');

        } else {
          btn.setAttribute('aria-label', 'Button');
        }
      });
    }

    // Run immediately
    fixEmptyButtons();

    // Run on every retry delay already scheduled by masterA11yRunner
    // Also watch DOM for any new buttons injected dynamically
    if (!window._emptyBtnObserver) {
      window._emptyBtnObserver = new MutationObserver(function(mutations) {
        var shouldRun = false;
        for (var i = 0; i < mutations.length; i++) {
          var addedNodes = mutations[i].addedNodes;
          for (var j = 0; j < addedNodes.length; j++) {
            var node = addedNodes[j];
            if (node.nodeType === 1) {
              if (node.tagName === 'BUTTON' || (node.querySelector && node.querySelector('button'))) {
                shouldRun = true;
                break;
              }
            }
          }
          if (shouldRun) break;
        }
        if (shouldRun) fixEmptyButtons();
      });
      window._emptyBtnObserver.observe(document.body, { childList: true, subtree: true });
    }

    // 7. Fix redundant, suspicious, and long alt text on images
    var altFixes = [
      // ── REDUNDANT: icon next to visible text — make decorative ──
      { src: 'Hand_Bean_Icon_Green.svg', alt: '' },
      // ── SUSPICIOUS: remove "Image of" prefix ────────────────────
      { src: 'artizan-organic-reserve-front.png', alt: 'Organic Reserve Nespresso Pods for Original Machines' },
      { src: 'stout-front.png', alt: 'Organic Stout Nespresso Original-Line Pods' },
      // ── LONG: shorten verbose alt text ──────────────────────────
      { src: 'Mushroom_Coffee_Flight.webp', alt: 'Mushroom Coffee Flight — Nespresso Original sampler' },
      { src: 'Cuba_Mia_Decaf', alt: 'Organic Cuba Mia Decaf espresso in red Nespresso capsules' },
    ];

    altFixes.forEach(function(fix) {
      document.querySelectorAll('img[src*="' + fix.src + '"]').forEach(function(img) {
        img.setAttribute('alt', fix.alt);
      });
    });

    // ── Generic sweep: fix ALL images sitewide ───────────────────
    document.querySelectorAll('img[alt]').forEach(function(img) {
      var alt = img.getAttribute('alt').trim();
      if (!alt) return; // skip decorative (empty alt is correct)

      var changed = false;

      // 1. Remove "Image of / Photo of / Picture of" prefix
      if (/^(image|photo|picture|icon|graphic|screenshot)\s+(of\s+)?/i.test(alt)) {
        alt = alt.replace(/^(image|photo|picture|icon|graphic|screenshot)\s+(of\s+)?/i, '').trim();
        changed = true;
      }

      // 2. Remove trailing filler phrases
      if (/[\.\s]*(main image|new box|main photo|product photo|product image)\s*$/i.test(alt)) {
        alt = alt.replace(/[\.\s]*(main image|new box|main photo|product photo|product image)\s*$/i, '').trim();
        changed = true;
      }

      // 3. Remove trailing dash (truncated alt)
      if (/[-–]\s*$/.test(alt)) {
        alt = alt.replace(/[-–]\s*$/, '').trim();
        changed = true;
      }

      // 4. Trim to 100 chars at last complete word boundary
      if (alt.length > 100) {
        alt = alt.substring(0, 100).replace(/\s+\S*$/, '').trim();
        alt = alt.replace(/[,.\s]+$/, '').trim();
        changed = true;
      }

      if (changed) {
        img.setAttribute('alt', alt);
      }
    });

    // ── Generic sweep: fix ALL video aria-labels sitewide ────────
    document.querySelectorAll('video').forEach(function(video) {
      var label = video.getAttribute('aria-label') || '';

      // Fix "Image of" prefix in video labels
      if (/^(image|photo|picture)\s+of\s+/i.test(label)) {
        label = label.replace(/^(image|photo|picture)\s+of\s+/i, '').trim();
      }

      // Trim long video labels
      if (label.length > 100) {
        label = label.substring(0, 100).replace(/\s+\S*$/, '').trim();
      }

      if (label) {
        video.setAttribute('aria-label', label);
      } else {
        var fallbackImg = video.querySelector('img[alt]');
        if (fallbackImg && fallbackImg.getAttribute('alt').trim()) {
          label = fallbackImg.getAttribute('alt').trim();
          if (label.length > 100) {
            label = label.substring(0, 100).replace(/\s+\S*$/, '').trim();
          }
          video.setAttribute('aria-label', label);
        } else {
          video.setAttribute('aria-label', 'Background video');
          video.setAttribute('aria-hidden', 'true');
        }
      }

      // Sync inner fallback img alt to match video label
      var inner = video.querySelector('img');
      if (inner) {
        inner.setAttribute('alt', video.getAttribute('aria-label'));
      }

      // Ensure role="img" so AT treats it as labeled media
      if (!video.hasAttribute('role')) {
        video.setAttribute('role', 'img');
      }
    });

    // 8. Fix long alt text — specific image replacements
    var longAltFixes = [
      { src: 'CubaMia-12-Main_ec4be940', alt: 'Organic Cuba Mia Double Espresso ESE Pods, dark roast, 12-pack' },
      { src: '03_15.png', alt: 'Ground coffee falling into a portafilter for espresso' },
      { src: 'Lighttells_CM-200', alt: 'Lighttells CM-200 portable coffee roast analyzer with case' },
      { src: 'Skywalker-Electric-Drum-Coffee-Roaster', alt: 'Skywalker electric drum coffee roaster, 500g capacity' },
      { src: '7a1b7714fc094e47beccb731befde2d8', alt: 'Cuba Mia Nespresso capsules brewing into a glass cup' },
      { src: 'Cuba_Mia_01_7aeaed88', alt: 'Cuba Mia coffee cup and packaging — Bold Heritage, Authentic Flavor' },
      { src: 'artboard-37-685b186f2f345ed2edc11f67', alt: "Lion's Mane and Chaga Mushroom Coffee capsules for Nespresso Original" },
      { src: 'Heavenly_Project_Decaf', alt: 'Organic Heavenly Project Decaf coffee cup and packaging' },
      { src: 'Stout_060fbfd2', alt: 'Organic Stout bold roast coffee cup and packaging' },
      { src: 'Colombia_d6e925e1', alt: 'Organic Colombia Single Origin — red fruit and caramel notes' }
    ];

    longAltFixes.forEach(function(fix) {
      document.querySelectorAll('img[src*="' + fix.src + '"]').forEach(function(img) {
        img.setAttribute('alt', fix.alt);
      });
    });

    // 10. Duplicate nearby alt text — make each unique by src filename
    var duplicateAltFixes = [
      { src: '64mm_Cast_Steel_Burrs_CODY_II_1', alt: '64mm Cast Steel Burrs for CODY II grinder' },
      { src: '64mm_Titanium-Coated_Cast_Steel_Burrs_CODY_II_1', alt: '64mm Titanium-Coated Cast Steel Burrs for CODY II grinder' }
      // Add more pairs here as WAVE reports them
    ];

    duplicateAltFixes.forEach(function(fix) {
      document.querySelectorAll('img[src*="' + fix.src + '"]').forEach(function(img) {
        img.setAttribute('alt', fix.alt);
      });
    });

    // 11. Missing fieldset — wrap grouped filter/sort checkboxes
    (function fixMissingFieldsets() {

      var filterForms = document.querySelectorAll(
        'form[id*="facets"], form[id*="filter"], #FacetFiltersForm, #FacetFiltersFormMobile, .facets__form'
      );

      filterForms.forEach(function(form) {
        var groups = form.querySelectorAll(
          '.facets__group, .facet-filters__field, [data-filter-group], .facets__display'
        );

        groups.forEach(function(group) {
          if (group.closest('fieldset')) return;

          var heading = group.querySelector(
            '.facets__heading, .facet-filters__label, h2, h3, h4, summary, [data-filter-heading]'
          );

          var checkboxes = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');
          if (checkboxes.length === 0) return;

          var fieldset = document.createElement('fieldset');
          fieldset.style.border = 'none';
          fieldset.style.margin = '0';
          fieldset.style.padding = '0';

          var legend = document.createElement('legend');
          legend.style.padding = '0';
          legend.style.fontWeight = 'inherit';
          legend.style.fontSize = 'inherit';
          legend.style.float = 'left';
          legend.style.width = '100%';

          if (heading) {
            legend.textContent = heading.textContent.trim();
          } else {
            var firstId = checkboxes[0].getAttribute('id') || '';
            var derived = firstId
              .replace(/checkbox-facets[^-]*-/i, '')
              .replace(/filter-p-m-[^-]*-/i, '')
              .replace(/[-_]/g, ' ')
              .trim();
            legend.textContent = derived.charAt(0).toUpperCase() + derived.slice(1) || 'Filter options';
          }

          group.parentNode.insertBefore(fieldset, group);
          fieldset.appendChild(legend);
          fieldset.appendChild(group);
        });
      });

      // Fallback: find any loose checkbox label groups NOT inside a fieldset
      var facetLabels = document.querySelectorAll(
        'label[for*="checkbox-facets"], label[for*="filter-"]'
      );

      var parentMap = new Map();
      facetLabels.forEach(function(label) {
        var parent = label.closest('ul, ol, div:not(fieldset)');
        if (!parent) return;
        if (parent.closest('fieldset')) return;
        if (!parentMap.has(parent)) parentMap.set(parent, []);
        parentMap.get(parent).push(label);
      });

      parentMap.forEach(function(labels, parent) {
        if (labels.length < 2) return;
        if (parent.closest('fieldset')) return;

        var fieldset = document.createElement('fieldset');
        fieldset.style.border = 'none';
        fieldset.style.margin = '0';
        fieldset.style.padding = '0';

        var legend = document.createElement('legend');
        legend.style.padding = '0';
        legend.style.float = 'left';
        legend.style.width = '100%';

        var prevSibling = parent.previousElementSibling;
        var legendText = '';
        if (prevSibling && /^H[1-6]$/.test(prevSibling.tagName)) {
          legendText = prevSibling.textContent.trim();
        } else {
          var forAttr = labels[0].getAttribute('for') || '';
          legendText = forAttr
            .replace(/checkbox-facets[^-]*--/gi, '')
            .replace(/filter-p-m-[^-]*-/gi, '')
            .replace(/[-_]/g, ' ')
            .split(' ')[0] || 'Filter options';
          legendText = legendText.charAt(0).toUpperCase() + legendText.slice(1);
        }
        legend.textContent = legendText;

        parent.parentNode.insertBefore(fieldset, parent);
        fieldset.appendChild(legend);
        fieldset.appendChild(parent);
      });

    })();

    // 12. Fix unit-price contrast — WAVE ignores CSS var overrides on web components
    document.querySelectorAll('unit-price, unit-price.text-subdued').forEach(function(el) {
      el.style.setProperty('color', '#0F3E36', 'important');
      el.style.setProperty('--text-subdued', '#0F3E36', 'important');
      el.querySelectorAll('*').forEach(function(child) {
        child.style.setProperty('color', '#0F3E36', 'important');
      });
    });

    // 13. Fix missing alt on video poster/thumbnail fallback images
    document.querySelectorAll('img[src*="preview_images"], img[src*="thumbnail"]').forEach(function(img) {
      if (img.hasAttribute('alt')) return;
      var parentVideo = img.closest('video');
      if (parentVideo) {
        var videoLabel = parentVideo.getAttribute('aria-label');
        if (videoLabel && videoLabel.trim()) {
          img.setAttribute('alt', videoLabel.trim());
        } else {
          img.setAttribute('alt', '');
        }
        return;
      }
      img.setAttribute('alt', '');
    });

    // Also catch specifically these two files
    document.querySelectorAll('img[src*="486a87d901524fd7af0a840bee2fe19b"]').forEach(function(img) {
      if (!img.hasAttribute('alt')) {
        var parentVideo = img.closest('video');
        var label = parentVideo ? parentVideo.getAttribute('aria-label') : '';
        img.setAttribute('alt', label || '');
      }
    });

    // 14. Fix sale-price and compare-at-price contrast on custom background product cards
    // Foreground #4b6359 on #dfd6be = 4.49:1 — below 4.5:1 threshold
    // Fix: darken to #3d5249 which gives 5.1:1 on #dfd6be
    document.querySelectorAll(
      '.product-card[style*="--background"], .product-card.bg-custom, .product-card[style*="--text-color"]'
    ).forEach(function(card) {
      card.querySelectorAll(
        'sale-price.text-subdued, sale-price.text-subdued span, sale-price.text-on-sale, sale-price.text-on-sale span, compare-at-price.text-subdued, compare-at-price.text-subdued span, compare-at-price.line-through, compare-at-price.line-through span'
      ).forEach(function(el) {
        el.style.setProperty('color', '#3d5249', 'important');
      });
    });

    // Fix videos with no aria-label at all
    document.querySelectorAll('video:not([aria-label])').forEach(function(video) {
      var fallbackImg = video.querySelector('img[alt]');
      if (fallbackImg && fallbackImg.getAttribute('alt').trim()) {
        video.setAttribute('aria-label', fallbackImg.getAttribute('alt'));
        video.setAttribute('role', 'img');
      } else {
        video.setAttribute('aria-label', 'Decorative background video');
        video.setAttribute('role', 'img');
        video.setAttribute('aria-hidden', 'true');
      }
    });

  }

  // Schedule retries on DOMContentLoaded
  function scheduleAll() {
    delays.forEach(function(delay) {
      setTimeout(runAllFixes, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAll);
  } else {
    scheduleAll();
  }

  // Additional retries after full page load
  window.addEventListener('load', function() {
    setTimeout(runAllFixes, 500);
    setTimeout(runAllFixes, 3000);
    setTimeout(runAllFixes, 8000);
  });

})();